import {Stack, Text, Icon, Button} from "@chakra-ui/react";
import { FaExclamationTriangle } from "react-icons/fa";
import PropTypes from "prop-types";

function EmailVerifyNotification({ loading, onClickResend, isSent }) {
  return (
    <Stack
      display={'flex'}
      alignItems={'center'}
      flexDirection={'row'}
      justifyContent={'center'}
      spacing={2}
      bgColor={"orange.300"}
      py={1}
      px={2}
    >
      <Icon color={"white"}>
        <FaExclamationTriangle size={"xl"} />
      </Icon>
      <Text display={'flex'} color={"white"}>Please validate your email address</Text>
      <Button
        bgColor={"orange.100"}
        className={"capitalize"}
        onClick={onClickResend}
        size={"sm"}
        textTransform={"uppercase"}
        fontSize={12}
        isLoading={loading}
        disabled={loading || isSent}
      >
        resend
      </Button>
    </Stack>
  );
}

EmailVerifyNotification.propTypes = {
  loading: PropTypes.bool,
  onClickResend: PropTypes.func,
  isSent: PropTypes.bool,
}

export default EmailVerifyNotification;